export default "__VITE_ASSET__CoZzAILr__"